import React, { useEffect, useRef } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Thermometer from "react-thermometer-component";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import { useSelector } from "react-redux";
import { useAppContext } from "providers/AppProvider";

const TriageAssessmentCard = ({
  watch,
  setValue,
  control,
  name = "temperature",
  label = "Temperature",
  subLabel = "°C",
  min = 34.5,
  max = 46.5,
  required = false,
}) => {
  const { stepFormData } = useSelector((state) => state.preauthorization);
  const hasSetInitial = useRef(false);
  const {
    config: { theme },
  } = useAppContext();

  // One-time initialization from stepFormData
  useEffect(() => {
    if (stepFormData?.temperature && !hasSetInitial.current) {
      const parsed = parseFloat(stepFormData.temperature);
      if (!isNaN(parsed) && parsed >= min && parsed <= max) {
        setValue(name, parsed);
        hasSetInitial.current = true;
      }
    }
  }, [stepFormData, name, setValue, min, max]);

  // Watch value safely
  const rawValue = watch(name);
  const value =
    rawValue !== undefined && rawValue !== null && !isNaN(rawValue)
      ? parseFloat(rawValue)
      : min;

  const handleSliderChange = (e) => {
    const val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      setValue(name, val, { shouldValidate: true });
    }
  };

  const handleTextChange = (e) => {
    const val = e?.target?.value.trim();
    if (val === "") {
      // Optionally reset to min or keep the current value
      setValue(name, 0, { shouldValidate: true });
      return;
    }
    const floatVal = parseFloat(val);
    if (!isNaN(floatVal) && floatVal >= min && floatVal <= max) {
      setValue(name, floatVal, { shouldValidate: true });
    }
  };

  return (
    <Row className="sign-vital">
      <Col xs={9}>
        <div className="d-flex flex-column w-100">
          <div className="d-flex align-items-end justify-content-between w-100">
            <h5 className="fs-11 mb-0" style={{ flex: 1 }}>
              {label}
            </h5>
            <span className="fs-12">{subLabel}</span>
          </div>

          {/* Numeric Input */}
          <TextInput
            name={name}
            control={control}
            required={required}
            size="sm"
            type="number"
            min={min}
            max={max}
            step="0.1"
            onChange={handleTextChange}
            style={{ flex: 1, marginTop: "8px" }}
          />

          {/* Slider */}
          <div className="d-flex align-items-center gap-2 mt-2">
            <h6 className="text-muted fs-11">{min}</h6>
            <Form.Range
              min={min}
              max={max}
              step={0.1}
              value={value}
              onChange={handleSliderChange}
              style={{ flex: 1 }}
            />
            <h6 className="text-muted fs-11">{max}</h6>
          </div>
        </div>
      </Col>

      <Col xs={3}>
        <div
          style={{
            borderRadius: "10px",
            padding: "8px",
            height: "100%",
          }}
          className="d-flex align-items-center justify-content-center flex-column"
        >
          <Thermometer
            theme="light"
            value={value}
            min={min}
            max={max}
            format="°C"
            size="small"
          />
        </div>
      </Col>
    </Row>
  );
};

export default TriageAssessmentCard;
